module.exports = __webpack_public_path__ + "static/media/ng.520463e1.svg";